export default __webpack_public_path__ + "static/media/3055.bad5d0dd.jpg";